module.exports = __webpack_public_path__ + "img/mortar-board.afad78df.svg";